// extracted by mini-css-extract-plugin
export default {"root":"jCUqo","warning":"pRF6T","error":"cY1SL","success":"FJUfs","note":"XcTMs","brand":"Kcf_3"};